import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./AllBlog.css";

const AllBlog = () => {
  return (
    <div>
      <Header />
      
      <SubHeader title='Blogs' text='Paintings'  width='container'/>
      

      <div className="blog-container text-white">
        <div className="container py-3">
          {/* Fair News section  */}
          <h1 className="pt-5">Fair News</h1>
          <div className="row py-2 ">
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img 
                  src={require("../../Asset/blog/Group 229.png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4 col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (1).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body ">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4 col-lg-4 col-md-4 col-sm-6 pb-3">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (2).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body ">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4 col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (3).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body ">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4 col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (4).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body ">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4 col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232.png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Art section */}
          <h1 className="pt-5">Art News</h1>
          <div className="row py-2 ">
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (5).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (6).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div cursor">
                <img
                  src={require("../../Asset/blog/Group 232 (7).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AllBlog;
